import colors from '../globals/colors';
const buttons = {
    variant: {
        black: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: colors.grey72,
                    borderColor: colors.grey72,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: colors.grey100,
                    borderColor: colors.grey100,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: colors.grey84,
                    borderColor: colors.grey84,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: colors.grey84,
                    borderColor: 'transparent',
                    outline: colors.tertiary.lighten,
                },
            },
            outline: {
                idle: {
                    color: colors.grey72,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey72,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey100,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey100,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey84,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey84,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey84,
                    backgroundColor: colors.grey0,
                    borderColor: 'transparent',
                    outline: colors.tertiary.lighten,
                },
            },
            link: {
                idle: {
                    color: colors.grey72,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey100,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey84,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey84,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
            },
        },
        zonajobs: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: '#FE633F',
                    borderColor: '#FE633F',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: '#EB4C2A',
                    borderColor: '#EB4C2A',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: '#FF795A',
                    borderColor: '#FF795A',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: '#FE633F',
                    borderColor: '#FE633F',
                    outline: 'transparent',
                },
            },
        },
        primary: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: colors.primary.normal,
                    borderColor: colors.primary.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: colors.primary.darken,
                    borderColor: colors.primary.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: colors.primary.lighten,
                    borderColor: colors.primary.lighten,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: colors.primary.normal,
                    borderColor: colors.primary.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            outline: {
                idle: {
                    color: colors.primary.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.primary.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.primary.darken,
                    backgroundColor: colors.primary.ultraLighten,
                    borderColor: colors.primary.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.primary.darken,
                    backgroundColor: colors.primary.ultraLighten,
                    borderColor: colors.primary.darken,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.primary.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.primary.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            link: {
                idle: {
                    color: colors.primary.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                active: {
                    color: colors.primary.darken,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.primary.lighten,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.primary.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
            },
        },
        secondary: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: colors.secondary.normal,
                    borderColor: colors.secondary.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: colors.secondary.darken,
                    borderColor: colors.secondary.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: colors.secondary.lighten,
                    borderColor: colors.secondary.lighten,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: colors.secondary.normal,
                    borderColor: colors.secondary.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            outline: {
                idle: {
                    color: colors.secondary.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.secondary.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.secondary.darken,
                    backgroundColor: colors.secondary.ultraLighten,
                    borderColor: colors.secondary.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.secondary.darken,
                    backgroundColor: colors.grey0,
                    borderColor: colors.secondary.darken,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.secondary.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.secondary.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            link: {
                idle: {
                    color: colors.secondary.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                active: {
                    color: colors.secondary.darken,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.secondary.lighten,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.secondary.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
            },
        },
        gray: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: colors.grey60,
                    borderColor: colors.grey60,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: colors.grey100,
                    borderColor: colors.grey100,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: colors.grey84,
                    borderColor: colors.grey84,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: colors.grey84,
                    borderColor: 'transparent',
                    outline: colors.tertiary.lighten,
                },
            },
            link: {
                idle: {
                    color: colors.grey60,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey100,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey84,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey84,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
            },
        },
        hiring: {
            fill: {
                idle: {
                    color: colors.grey0,
                    backgroundColor: colors.hiring.normal,
                    borderColor: colors.hiring.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey0,
                    backgroundColor: colors.grey24,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.grey0,
                    backgroundColor: colors.hiring.darken,
                    borderColor: colors.hiring.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.grey0,
                    backgroundColor: colors.hiring.lighten,
                    borderColor: colors.hiring.lighten,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.grey0,
                    backgroundColor: colors.hiring.normal,
                    borderColor: colors.hiring.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            outline: {
                idle: {
                    color: colors.hiring.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.hiring.normal,
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: colors.grey0,
                    borderColor: colors.grey24,
                    outline: 'transparent',
                },
                active: {
                    color: colors.hiring.darken,
                    backgroundColor: colors.hiring.ultraLighten,
                    borderColor: colors.hiring.darken,
                    outline: 'transparent',
                },
                hover: {
                    color: colors.hiring.darken,
                    backgroundColor: colors.grey0,
                    borderColor: colors.hiring.darken,
                    outline: 'transparent',
                },
                focus: {
                    color: colors.hiring.normal,
                    backgroundColor: colors.grey0,
                    borderColor: colors.hiring.normal,
                    outline: colors.tertiary.lighten,
                },
            },
            link: {
                idle: {
                    color: colors.hiring.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                disabled: {
                    color: colors.grey24,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                active: {
                    color: colors.hiring.darken,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                hover: {
                    color: colors.hiring.lighten,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
                focus: {
                    color: colors.hiring.normal,
                    backgroundColor: 'transparent',
                    borderColor: 'transparent',
                    outline: 'transparent',
                },
            },
        },
    },
    size: {
        small: {
            fontSize: '14px',
            lineHeight: '34px',
            withoutText: '36px',
        },
        medium: {
            fontSize: '16px',
            lineHeight: '46px',
            withoutText: '48px',
        },
        large: {
            fontSize: '18px',
            lineHeight: '58px',
            withoutText: '60px',
        },
    },
};
export default buttons;
